/* eslint-disable camelcase */
/* eslint-disable react/display-name */
/**
 * @file GeneralSocialTSocialRiskView.jsx
 * @author Daniel Aguirre
 * @description GeneralSocialTSocialRisk View Page
 */

// Dependencies
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import DashboardCard from 'components/DashboardCard';
import { useHistory } from 'react-router';
import DashboardDoughnut from 'components/Charts/DashboardDoughnut';
import styleGuideColors from 'commons/styleGuideColors';
import useTruncateAndFormat from 'hook/useTruncateAndFormat';

/**
 * GeneralSocialTSocialRisk View
 * @param { Object } dashboardStaffActions - DashboardStaff Actions.
 * @return { Node } React node.
 */

function GeneralSocialTSocialRiskView({ dashboardStaffActions, clinicId }) {
  const { t: translate } = useTranslation();
  const history = useHistory();
  const [chartData, setChartData] = useState(null);

  const { getGeneralSocialTSocialRisk } = dashboardStaffActions;

  const onGetData = (_, resp) => {
    let data = [];
    const classifications = [
      {
        label: 'Alto',
        classification: 'Alto',
        color: styleGuideColors.alertError
      },
      {
        label: 'Medio',
        classification: 'Medio',
        color: styleGuideColors.graphYellow
      },
      {
        label: 'Bajo',
        classification: 'Bajo',
        color: styleGuideColors.baxterBrandTeal
      },
      {
        label: 'Sin registro',
        classification: 'Sin registro',
        color: styleGuideColors.graphGreyStrokes
      }
    ];

    let total = 0;

    if (resp?.data) {
      resp.data.forEach(({ cantidad }) => {
        total += cantidad;
      });
      classifications.forEach(({ label, classification, color }) => {
        const respElement = resp.data.find(
          ({ clasificacion }) => clasificacion === classification
        );
        if (respElement) {
          const value = (respElement.cantidad * 100) / total;
          data = [
            ...data,
            {
              value: useTruncateAndFormat(value, 2),
              label: translate(`dashboardStaff.${label}`),
              color,
              cantidad: respElement.cantidad,
              classification
            }
          ];
        }
      });
      setChartData(data);
    } else {
      setChartData([]);
    }
  };

  useEffect(() => {
    setChartData(null);
    getGeneralSocialTSocialRisk({ clinicId }, onGetData);
  }, [translate, clinicId]);

  const handleDetailClick = (index) => {
    const { classification, cantidad: totalItems } = chartData[index];
    history.push(
      `/main/dashboard-detail/general-social-t-social-risk-list/${classification}/${totalItems}`
    );
  };

  return (
    <DashboardCard id="F38" loading={!chartData}>
      <DashboardDoughnut
        title={translate('dashboardStaff.generalSocialTSocialRisk')}
        dataValues={chartData || []}
        onDetailClick={handleDetailClick}
      />
    </DashboardCard>
  );
}

/**
 * Component definition of proptypes.
 */
GeneralSocialTSocialRiskView.propTypes = {
  dashboardStaffActions: PropTypes.shape({
    getGeneralSocialTSocialRisk: PropTypes.func.isRequired
  }),
  clinicId: PropTypes.any
};

export default GeneralSocialTSocialRiskView;
